let filtro = document.querySelectorAll(".m-collection-toolbar")[0];
let productList = document.querySelectorAll(".facest-filters-section")[0];
let menuFiltros = document.querySelector(".m-sidebar--fixed .m-sidebar");
function filtroSticky(){
  var productCord = productList.getBoundingClientRect();
  var posicion = filtro.getBoundingClientRect();
  if(window.innerWidth < 700){
  menuFiltros.style.top=`${posicion.bottom}px`;
  }
  if(productCord.top < 50){
    if (filtro.classList.contains("m-collection-toolbar--sticky") == false){
      filtro.classList.add("m-collection-toolbar--sticky")
    }
  }else if (productCord.top > 50){
    if(filtro.classList.contains("m-collection-toolbar--sticky")){
      filtro.classList.remove("m-collection-toolbar--sticky")
    }
  }
}

document.addEventListener("scroll",filtroSticky)


var openFilter= document.querySelector(".m-sidebar--open");
function checkPositionFilter(){
  var posicion = filtro.getBoundingClientRect();
  if(window.innerWidth < 700){
    menuFiltros.style.top=`${posicion.bottom}px`;
  }
}


openFilter.addEventListener("click",checkPositionFilter)